import { UserLinked } from './contact';

export interface Trade {
    id?: string;
    trades?: TradeElement[];
    trading_account?: string;
    symbol?: string;
    users_linked?: UserLinked[];
    tenant?: string;
}

export interface TradeElement {
    ticket_id?: number;
    digits?: number;
    cmd?: string;
    volume?: number;
    open_time?: Date;
    open_price?: number;
    sl?: number;
    tp?: number;
    close_time?: Date;
    expiration?: Date;
    reason?: string;
    conv_rate1?: number;
    conv_rate2?: number;
    commission?: number;
    commission_agent?: number;
    swaps?: number;
    close_price?: number;
    profit?: number;
    taxes?: number;
    comment?: string;
    internal_id?: number;
    margin_rate?: number;
    platform_timestamp?: Date;
    magic?: number;
    gw_volume?: number;
    gw_open_price?: number;
    gw_close_price?: number;
    platform_modify_time?: Date;
    platform_ticket?: string;
    platform_ticket_group?: string;
}
